import { UserCircleIcon as PhosphorUserCircleIcon } from "@phosphor-icons/react/dist/ssr/UserCircle";

import { createAppIcon } from "@/components/createAppIcon";

export const PersonLocationIcon = /* @__PURE__ */ createAppIcon(PhosphorUserCircleIcon);
